const bondType = {
  SavingsBonds: '13',
  Corporate: '03' //Corporate Bonds
};

const regisMM = {
  height: 64,
  width: 64,
  uploadFileSize: 10000 //PT required maximum 10kb
};

const status = {
  Draft: '1',
  Pending: '2',
  Approved: '3',
  Rejected: '4'
};

const MSStatus = {
  SAVE_DRAFT: 1, //บันทึกข้อมูล
  SAVE_SENDAPPROVE: 2, //บันทึกและส่งตรวจสอบ
  SAVE_APPROVE: 3, //อนุมัติเรียบร้อย
  SAVE_NOTAPPROVE: 4, //ไม่อนุมัติ
  SAVE_CANCEL: 5 //ไม่อนุมัติ
};

const Mode = {
  APP_ADD: 'APP_ADD',
  APP_EDIT: 'APP_EDIT',
  APP_DEL: 'APP_DEL',
  APP_COPY: 'APP_COPY',
  NEW_ADD: 'NEW_ADD',
  NEW_EDIT: 'NEW_EDIT',
  NEW_DEL: 'NEW_DEL',
  NEW_COPY: 'NEW_COPY',
  EDIT_ADD: 'EDIT_ADD',
  EDIT_EDIT: 'EDIT_EDIT',
  EDIT_COPY: 'EDIT_COPY',
  EDIT_DEL: 'EDIT_DEL',
  EDIT: 'EDIT',
  EDIT_DELETE: 'EDIT_DELETE',
  EDIT_TEMP: 'EDIT_TEMP'
  //if (Request["cmd"] == "EDIT_EDIT" || Request["cmd"] == "EDIT_COPY" || Request["cmd"] == "NEW_EDIT")
};

const StageAction = {
  STAGE_SEARCH: 'SEARCH',
  STAGE_NEW: 'NEW',
  STAGE_EDIT: 'EDIT',
  STAGE_DELETE: 'DELETE',
  STAGE_EDIT_DELETE: 'EDIT_DELETE',
  STAGE_APPROVE_DELETE: 'APPROVE_DELETE',
  STAGE_APPROVE: 'APPROVE',
  STAGE_PROCESS: 'PROCESS',
  STAGE_PRINT: 'PRINT',
  STAGE_VIEW: 'VIEW',
  STAGE_CANCEL: 'CANCEL',
  STAGE_APPROVE_CANCEL: 'APPROVE_CANCEL'
};

const AlertType = {
  ALERTTYPE_SUCCESS: 'success',
  ALERTTYPE_WARNING: 'warning',
  ALERTTYPE_ERROR: 'error'
};

const SearchQuota = {
  SEARCHQUOTA_SYMBOL: '1',
  SEARCHQUOTA_SELLINGAGENT: '2',
  SEARCHQUOTA_INVESTOR: '3'
};

const TellerCommandType = {
  TELLER_TYPE_ADD: 'A',
  TELLER_TYPE_EDIT: 'U',
  TELLER_TYPE_DELETE: 'D'
};

const RateLimit = {
  RATE_LIMIT_MAX_REQUEST: 5,
  RATE_LIMIT_MINUTE_WAIT: 3
};

export default {
  ...bondType,
  ...regisMM,
  ...status,
  ...MSStatus,
  ...Mode,
  ...StageAction,
  ...AlertType,
  ...SearchQuota,
  ...TellerCommandType,
  ...RateLimit
};
